import React, { useMemo } from 'react';
import { View, Text } from 'react-native';

import { font as initialFont } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { download, isWeb, shareFile } from '@helpers';
import { scale as initialScale } from '@components/frame';
import Svg from '@styles/icons/svg';
import TouchableElement from '@components/common/touchableElement';
import i18n from 'i18n-js';
import { DocumentPreviewIcon } from './documentPreviewIcon';
import Processing from '@v2/components/imageHandling/components/Processing';
import ExtensionLabel from './extensionLabel';

const Thumbnails = ({
  C,
  item,
  borderRadius,
  CC,
  alwaysDark,
  bg,
  width = '100%',
  height = '100%',
  withoutDownloadButton = false,
  withoutFileName = false,
  scale = initialScale,
  font = initialFont,
  processingContainerStyles,
}) => {
  const shouldApplyDarkModeColors = !!(CC && alwaysDark);

  const bgColor = bg ? bg : shouldApplyDarkModeColors ? CC('Button/Dark/Secondary') : C('Button/Light/Secondary');

  const textColor = shouldApplyDarkModeColors ? CC('Label/Dark/Quaternary') : C('Label/Light/Quaternary');

  const onDownloadPress = () => {
    if (isWeb) {
      download({ downloadUrl: item?.downloadUrl, fileName: item?.fileName });
      return;
    }
    shareFile({ setLoading: () => {}, url: item?.url });
  };

  return (
    <View
      style={[
        { width, height, justifyContent: 'center', alignItems: 'center', backgroundColor: bgColor },
        borderRadius != null && { borderRadius },
      ]}
    >
      {!withoutFileName && (
        <Text
          numberOfLines={1}
          ellipsizeMode={'middle'}
          style={[font['Caption 2'], { color: textColor, textAlign: 'center', textTransform: 'uppercase' }]}
        >
          {item.fileName}
        </Text>
      )}
      <DocumentPreviewIcon C={C} extension={item?.extensionOriginal} scale={scale} />
      <ExtensionLabel item={item} font={font} CC={CC} alwaysDark={alwaysDark} />
      {item?.isProcessing && <Processing containerStyles={processingContainerStyles ?? { bottom: scale(15) }} />}
      {!withoutDownloadButton && (
        <TouchableElement onPress={onDownloadPress}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                boxStyle,
                {
                  width: scale(264),
                  marginTop: scale(17),
                  borderRadius: scale(18),
                  paddingVertical: scale(12),
                  gap: scale(3),
                  alignItems: 'center',
                  backgroundColor: C(pressHoverColor('Button/Light/Primary')),
                },
              ]}
            >
              <Svg icon="download" width={scale(27)} height={scale(24)} color={C('Button/Light/Primary Text')} />
              <Text style={[font['Button 1'], { color: C('Button/Light/Primary Text') }]}>{i18n.t('Download')}</Text>
            </View>
          )}
        </TouchableElement>
      )}
    </View>
  );
};

export default ColorWrapper(Thumbnails);
